import { render, staticRenderFns } from "./target-pin.vue?vue&type=template&id=7f9a85fe&"
import script from "./target-pin.vue?vue&type=script&lang=js&"
export * from "./target-pin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports